module.exports = __webpack_public_path__ + "img/new_24.177deb80.jpg";